import { render, staticRenderFns } from "./aShopDetailSeckillOrders.vue?vue&type=template&id=50714911&scoped=true"
import script from "./aShopDetailSeckillOrders.vue?vue&type=script&lang=js"
export * from "./aShopDetailSeckillOrders.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailSeckillOrders.vue?vue&type=style&index=0&id=50714911&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50714911",
  null
  
)

export default component.exports